module.exports = require("angular-translate");